import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Pie } from 'react-chartjs-2';

//fonctionnalites,designEtUxUi,technologie,delais,equipe,

export const ResultPieChart = ({dataPie})=>{

    ChartJS.register(ArcElement, Tooltip, Legend);
    const data = {
        labels: ['Fonctionnalités', 'Design et UX/UI', 'Technologie', 'Délais', 'Équipe'],
        datasets: [
          {
            data: [dataPie?.fonctionnalites, dataPie?.designEtUxUi, dataPie?.technologie, dataPie?.delais, dataPie?.equipe],
            backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#FF8042', '#00C49F'],
            borderWidth: 1,
            hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56', '#FF8042', '#00C49F']
          }
        ]
      };
    return(

           <div className='flex flex-row justify-center items-center lg:h-[400px]'>
             <Pie data={data} />
           </div>

    )
}